(function (angular) {
  'use strict';

  angular.module('app',
    ['ui.router',
      'ui.bootstrap',
      'materialAdmin',
      'localytics.directives',
      'ng-file-model',
      'ui.codemirror',
      'ngCookies',
      'ngAnimate',
      'reports',
      'apiSpaces',
      'profiles',
      'Common',
      'appMessaging',
      'sms',
      'channels',
      'channels.email',
      'integration',
      'widget',
      'angular-confirm',
      'ngClipboard',
      'ngSanitize',
      'ui.sortable',
      'settings',
      'monospaced.elastic',
      'chat2',
      'reports',
      'phoneValidation',
      'branchReports',
      'appMessagingReports',
      'smsReports',
      'verifyReports',
      'webChatReports',
      'broadcastReports',
      'shared',
      'zInfiniteScroll',
      'broadcast',
      'angularMoment',
      'naif.base64',
      'color.picker',
      'angular-clockpicker',
      'messenger',
      'customChannel',
      'twitter',
      'whatsApp',
      'branch',
      'angular-inview',
      'inboundRules',
      'dataPreferences',
      'ui.mask',
      'vs-repeat',
      'mgo-angular-wizard',
      'dashboard',
      'templates',
      'forms',
      'rcs'
    ]).constant('totpStatus', {
      Disabled: 0,
      Enrolling: 1,
      Enabled: 2
    });

})(window.angular);
